import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listMembers } from '@ebalance/proto/bffuser/v1/user_directory_service-UserDirectoryService_connectquery'
import {
  ListMembersRequestSchema,
  type ListMembersResponse,
} from '@ebalance/proto/bffuser/v1/user_directory_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

type Options = {
  /**
   * 補助表示 (= 監査情報の member 表示名解決 `useMemberDisplayName`) 用。
   * true にすると取得失敗時に error boundary (全画面エラー) へ飛ばさず、
   * cache も長め (5 分) に保持して一覧テーブル各行からの参照で refetch を抑える。
   * member 一覧が本質的に必要な画面 (担当者 Select 等) は既定 (false) のまま使う。
   */
  failSafe?: boolean
}

/**
 * BFF UserDirectoryService.ListMembers を TanStack Query で取得する hook。
 *
 * ページ横断で再利用する (= AdminWorkflowTemplates の担当者 Select、 WorkflowCaseDetail の
 * サブステップ担当者表示・エディタ・完了者表示名解決、 監査情報の表示名解決) ため
 * `~/hooks/member/` に置く (frontend/apps/ebalance/CLAUDE.md 「hook は page-local が
 * default。 複数ページで再利用する hook のみ共有 src/hooks/<context>/」 に従う)。
 */
export function useListMembers(
  options?: Options,
): UseQueryResult<ListMembersResponse, ConnectError> {
  return useQuery(
    listMembers,
    create(ListMembersRequestSchema, {}),
    options?.failSafe === true
      ? { throwOnError: false, staleTime: 5 * 60 * 1000 }
      : undefined,
  )
}
